import { render, staticRenderFns } from "./ViizHeader.vue?vue&type=template&id=b5889ee6"
import script from "./ViizHeader.vue?vue&type=script&lang=js"
export * from "./ViizHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports